export const CONTACT_TYPE_INVOICING_ADDRESS = 'invoicingAddress';
export const CONTACT_MEDIUM_TYPE_POSTAL_ADDRESS = 'postalAddress';

/**
 * Model representing the BillingAccount address.
 *
 * @property {string} street
 * @property {string} streetNumber
 * @property {string} city
 * @property {string} postCode
 */
export default class BillingAccountAddress {
  /**
   * @param {?string} street
   * @param {?string} streetNumber
   * @param {?string} city
   * @param {?string} postCode
   */
  constructor({ street = '', streetNumber = '', city = '', postCode = '' }) {
    this.street = street;
    this.streetNumber = streetNumber;
    this.city = city;
    this.postCode = postCode;
  }

  /**
   * Create PATCH operation body from this model's data.
   *
   * @param {string} contactType
   * @param {string} contactMedium
   * @return {{op: string, path: string, value: string}[]}
   */
  createPatchBody(
    contactType = CONTACT_TYPE_INVOICING_ADDRESS,
    contactMedium = CONTACT_MEDIUM_TYPE_POSTAL_ADDRESS,
  ) {
    return [
      this._createPatchOperation(contactType, contactMedium, 'street'),
      this._createPatchOperation(contactType, contactMedium, 'streetNumber'),
      this._createPatchOperation(contactType, contactMedium, 'city'),
      this._createPatchOperation(contactType, contactMedium, 'postCode'),
    ];
  }

  /**
   * @param {string} contactType
   * @param {string} contactMedium
   * @param {string} property
   * @return {{op: string, path: string, value: string}}
   * @private
   */
  _createPatchOperation(contactType, contactMedium, property) {
    return {
      op: 'replace',
      path: `contact[contactType='${contactType}']/contactMedium[mediumType='${contactMedium}']/characteristic/${property}`,
      value: this[property],
    };
  }
}
